import type { FilterStates, FilterStatesKey } from '../type/filter-state';

/**
 * Reset the filter states to the default values.
 * @param states The filter states to reset.
 * @param ignoreFilterKeys The filter keys to ignore.
 * @returns The updated filter states.
 */
export const resetFilterStates = (
    states: FilterStates,
    ignoreFilterKeys: FilterStatesKey[] = [],
): FilterStates => {
    Object.keys(states).forEach((filterKey) => {
        const currentKey = filterKey as keyof FilterStates;
        const state = states[currentKey];
        if (
            !state ||
            typeof state === 'number' ||
            typeof state === 'string' ||
            typeof state === 'boolean' ||
            (!Array.isArray(state) && !('kind' in state)) ||
            ignoreFilterKeys.includes(filterKey)
        )
            return;
        if (Array.isArray(state)) {
            state.forEach((singleState) => {
                if (
                    typeof singleState === 'number' ||
                    typeof singleState === 'string'
                )
                    return;
                singleState.state.items.forEach((item) => {
                    item.checked = false;
                });
                singleState.state.selectedItems = [];
            });
        } else {
            if (state.kind === 'Checkbox') {
                delete state.checked;
            } else if (state.kind === 'CheckboxGroup') {
                delete state.checkedItems;
            } else if (state.kind === 'CategorySelector') {
                delete state.selectedCategory;
            } else if (state.kind === 'RangeSelector') {
                delete state.value;
            } else if (state.kind === 'SearchList') {
                state.items.forEach((item) => {
                    item.checked = false;
                });
                state.selectedItems = [];
            } else if (state.kind === 'Location') {
                delete state.selectedLocation;
            } else if (state.kind === 'AwardsFilter') {
                delete state.checkedItems;
            } else {
                delete state.selectedItem;
            }
        }
    });
    return states;
};
